/**
 * Dokumenttitel, meta description och canonical för /event/:slug.
 *
 * Sätts client-side — Googlebot renderar JS så titel/description per
 * konsert ger SEO-värde redan nu. OG-taggar för länkdelningar kräver
 * prerender/SSR (crawlers från Facebook/Slack kör inte JS) — det är fas 2
 * i GROWTH_PLAN.md.
 */

const DEFAULT_TITLE =
  "LIVE GBG | Livemusik i Göteborg - Hitta konserter hos oss";
const DEFAULT_DESCRIPTION =
  "Bläddra igenom Göteborgs klubbspelningar och hitta din nästa livekonsert hos oss. Livemusik i Göteborg samlat på ett ställe.";
const BASE_URL = "https://www.livegbg.se";

function setMetaDescription(content) {
  let tag = document.querySelector('meta[name="description"]');
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", "description");
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setCanonical(href) {
  let tag = document.querySelector('link[rel="canonical"]');
  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", "canonical");
    document.head.appendChild(tag);
  }
  tag.setAttribute("href", href);
}

export function applyEventMeta(event) {
  if (!event || !event.title) return;

  const dateStr = event.date
    ? new Intl.DateTimeFormat("sv-SE", {
        day: "numeric",
        month: "long",
        year: "numeric",
        timeZone: "Europe/Stockholm",
      }).format(new Date(event.date))
    : "";

  const venuePart = event.venue ? ` på ${event.venue}` : "";
  const datePart = dateStr ? ` ${dateStr}` : "";

  document.title = `${event.title}${venuePart}${datePart} | LIVE GBG`;
  setMetaDescription(
    `${event.title} live${venuePart} i Göteborg${datePart}. Datum, info och biljetter på LIVE GBG.`
  );
  if (event.slug) {
    setCanonical(`${BASE_URL}/event/${event.slug}`);
  }
}

export function resetEventMeta() {
  document.title = DEFAULT_TITLE;
  setMetaDescription(DEFAULT_DESCRIPTION);
  setCanonical(`${BASE_URL}/`);
}
